import { useState, useEffect } from 'react';

import { useRouter } from 'next/router';

import {
  useMediaQuery,
  colors,
  Grid,
  FormControl,
  OutlinedInput,
  InputAdornment,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import { LoadingButton } from '@material-ui/lab';

import PropTypes from 'prop-types';

import { Icon } from '@/src/components/atoms';

const useStyles = makeStyles(theme => ({
  image: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: 400,
    },
  },
  searchInputContainer: {
    background: theme.palette.alternate.main,
    padding: theme.spacing(2),
    boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.11)',
    borderRadius: theme.spacing(1),
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    '& .MuiOutlinedInput-notchedOutline': {
      border: '0 !important',
    },
    '& .MuiInputAdornment-positionStart': {
      marginRight: theme.spacing(2),
    },
    '& .MuiOutlinedInput-adornedStart': {
      paddingLeft: 0,
    },
    '& .MuiOutlinedInput-input': {
      padding: 0,
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  searchButton: {
    maxHeight: 45,
    minWidth: 135,
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
    },
  },
}));

export default function Hero({ category, loading }) {
  const router = useRouter();
  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });
  const [input, setInput] = useState('');

  const { uid: categorySlug } = category;
  const { search = '' } = router.query;

  const handleFind = () =>
    router.push(
      { pathname: `/blog/category/[categorySlug]`, query: { search: input, categorySlug } },
      undefined,
      { shallow: true, scroll: false },
    );

  useEffect(() => {
    setInput(search);
  }, [search]);

  return (
    <Grid container justifyContent="space-between" spacing={isMd ? 4 : 2}>
      <Grid item xs={12}>
        <div className={classes.searchInputContainer}>
          <FormControl fullWidth variant="outlined">
            <OutlinedInput
              startAdornment={
                <InputAdornment position="start">
                  <Icon fontIconClass="fas fa-search" fontIconColor={colors.blueGrey[900]} />
                </InputAdornment>
              }
              placeholder="Buscar artigos"
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyPress={ev => {
                if (ev.key === 'Enter') {
                  handleFind();
                  ev.preventDefault();
                }
              }}
            />
          </FormControl>
          <LoadingButton
            loading={loading}
            loadingPosition="end"
            endIcon={<SearchIcon />}
            color="primary"
            variant="contained"
            size="large"
            className={classes.searchButton}
            onClick={handleFind}>
            Buscar
          </LoadingButton>
        </div>
      </Grid>
    </Grid>
  );
}

Hero.propTypes = {
  category: PropTypes.object,
  loading: PropTypes.bool,
};
